import { render, staticRenderFns } from "./FullTable.vue?vue&type=template&id=0b445b64&"
import script from "./FullTable.vue?vue&type=script&lang=js&"
export * from "./FullTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports